import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { PerformanceSummary, VendorJob } from '../../../../services/nswag/nswagclient';

@Component({
  selector: 'app-job-performance-summary',
  standalone: false,
  templateUrl: './job-performance-summary.component.html',
  styleUrls: ['./job-performance-summary.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => JobPerformanceSummaryComponent),
    multi: true
  }]
})
export class JobPerformanceSummaryComponent implements OnInit, ControlValueAccessor {

  private _onTouched: () => void = () => {};
  public isDisabled = false;

  @Input() _job: VendorJob = new VendorJob();
  get job() {
    return this._job;
  }
  set job(val: VendorJob) {
    this._job = val ?? new VendorJob();
    this.ensureJobDefaults(this._job);
    this.propagateChange(this._job);
  }

  constructor() { }

  ngOnInit() {
    this.ensureJobDefaults(this._job);
  }

  /****** ControlValueAccessor methods to handle ngModel read and updates ******/
  propagateChange = (_: any) => { };

  writeValue(obj: any): void {
    if (obj) {
      this._job = obj;
      this.ensureJobDefaults(this._job);
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  private ensureJobDefaults(job: VendorJob): void {
    if (!job.performanceSummary) {
      job.performanceSummary = new PerformanceSummary();
    }
  }
}
